/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

// Amplify configuration, taken from aws-exports.js
export default {
	aws_project_region: process.env.REACT_APP_AWS_REGION,
	aws_cognito_identity_pool_id: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
	aws_cognito_region: process.env.REACT_APP_AWS_REGION,
	aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
	aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
	oauth: {
		domain: process.env.REACT_APP_AWS_COGNITO_DOMAIN_URL,
		scope: ["email", "openid", "aws.cognito.signin.user.admin"],
		redirectSignIn: `${window.location.origin}/oauth-callback`,
		redirectSignOut: `${window.location.origin}/logout`,
		responseType: "code",
	},
	federationTarget: "COGNITO_USER_POOLS",
};
